<div class="landing-page-wrapper">

  <header class="hero-section">

    <div class="blue-part">
      <div class="club-intro">
        <h1>
          <span>Earn Rewards</span>
          <span>On Every Purchase</span>
        </h1>
        <p>
          Join KingClub and start saving money effortlessly. Earn discounts on every purchase and unlock exclusive perks as you level up!
        </p>
        <div class="actions">
          <button class="join-btn" (click)="joinKingClubBtnClicked()">
            Join Now
          </button>
          <button class="learn-more">
            Learn More
          </button>
        </div>
      </div>
    </div>

    <div class="grey-part">
      <div class="hero-text-area">
          <span [@slideInLeft] class="reward-part part-rew">Rew</span>
          <span [@slideInRight] class="reward-part part-ard">ard</span>
        <img class="hero-image" src="{{kingAseets.JumpingWoman}}" alt="jumping woman">
        
     </div>

       <div class="members">
        <div class="top-part">
          <div [@emergeFromBehind] class="program-text">Program</div>
        </div>
        <div class="bottom-part">
          <div class="users-box">
            <img src="{{kingAseets.Avatars}}" alt="member avatars">
            <span>
              +<span [countUp]="membersCount" [duration]="membersDuration"></span> &nbsp; Members
            </span>
          </div>
        </div>
      </div> 
    </div>

    <a class="home-link" href="/">
      <img src="{{kingAseets.KingLogoBlue}}" alt="kingiftcard homw page link">
    </a>

    <button class="join-btn fixed" (click)="joinKingClubBtnClicked()">
      Become A Member
    </button>

  </header>

  <main>

    <section class="summary">
      <ng-container *ngFor="let item of summaryItems; let lastItem = last">
        <span [ngClass]="{'title1': !isMobileView, 'text-b4': isMobileView, 'font-light': true}">{{item}}</span>
        <div *ngIf="!lastItem" class="yellow-dot-divider">
        </div>
      </ng-container>
    </section>

    <section class="rewards">
        <div class="rewards-image">
          <img src="{{kingAseets.Rewards}}" alt="rewards image">
        </div>
        <div class="rewards-info">
          <h2 class="font-regular"> What Is KingClub <span class="blue-keyword">Rewards</span>?</h2>
          <p>
            At KingClub, we believe loyalty should be rewarded. That’s why every time you buy a gift card, we return a portion of your payment back to you — to spend however you like, whenever you want. It’s effortless, automatic, and made for smart shoppers like you.
          </p>
        </div>
        <div class="level-info">
          <h2 class="font-regular"> Elevate Your Experience, Earn <span class="blue-keyword">More</span> As You Go.</h2>
          <p>
            With KingClub, your loyalty is rewarded. The more you shop, the more you save — unlocking higher tiers, greater discounts, exclusive benefits, and gift card rewards tailored to your level.          </p>
        </div>
        <div class="level-logos">
          <div class="loyalty-container">
            <ng-container *ngFor="let level of loyaltyLevels; let i = index">
              <div class="loyalty" (mouseover)="hoveredLevelIndex = i" (mouseleave)="hoveredLevelIndex = -1">
                <span class="level">{{level.level}}</span>
                <div class="logo-container">
                  <img src="{{level.icon}}" alt="{{level.level}}">
                </div>
              </div>
            </ng-container>

            <ng-container *ngFor="let level of loyaltyLevels; let i = index">
                <div [style.top]="level.top" [style.left]="level.left" [style.opacity]="isMobileView || hoveredLevelIndex === i ? '1' : '0'" class="percentage">
                  <div class="icon-container">
                    <img src="{{kingAseets.Percentage}}" alt="percentage icon">
                  </div>
                  <span>Up To 
                    <span>{{level.percentage}}%</span>
                  </span>
                </div>
              </ng-container>

          </div>
        </div>
    </section>

    <section class="why-king-club">
      <h2 class="font-regular"> Why Choose <span class="blue-keyword">KingClub</span></h2>
      <p class="text-b2 font-regular">KingClub is designed to make your shopping experience smarter, more rewarding, and hassle-free.</p>
      <div class="why-king-club-items">
        <ng-container *ngFor="let item of whyKingClubItems">
          <div class="why-king-club-card">
            <div class="why-king-club-card-container">
              <div *ngIf="!isMobileView" class="front-side">
                <span>{{item.title}}</span>
              </div>
              <div class="back-side">
                <span>{{item.title}}</span>
                <p>{{item.description}}</p>
              </div>
            </div>
          </div>
        </ng-container>

      </div>
    </section>

    <section class="banner">
      <div class="banner-box">
        <span>Start Saving Today</span>
        <p>Join KingClub now and turn your everyday shopping into big savings.</p>
        <button (click)="joinKingClubBtnClicked()">
          <ng-container *ngIf="isMobileView">
            Join Now
          </ng-container>
          <ng-container *ngIf="!isMobileView">
            Get Started Now
          </ng-container>
        </button>
      </div>
    </section>

    <section class="how-works">
      <h2 class="font-regular"> How KingClub <span class="blue-keyword">Reward System</span> Works</h2>

      <div class="process-container">
        <ng-container *ngFor="let item of howKingClubWorksItems; let i = index">
          <div  [ngClass]="'step' + (i + 1)">
            <div class="process-marker-container">
              <div class="horizontal-line"></div>
              <div class="logo-container">
                <img src="{{item.icon}}" alt="step{{i+1}} icon">
              </div>
            </div>
            <div class="process-content">
              <span #span1 class="process-title">
                {{i+1}}. &nbsp;{{item.title}}
              </span>
              <span #span2 class="process-description">
                {{item.description}}
              </span>
            </div>

          </div>
        </ng-container>
      </div>    
    </section>

    <section class="testimonial">
      <h2 class="font-regular"> What Our <span class="blue-keyword">Testimonials</span> Are Saying </h2>
      <div [class.testimonial-carousel]="isMobileView">
        <div class="testimonial-container" id="testimonialContainer">
          <ng-container *ngFor="let item of testimonials">
            {{item.commemt}}
            <div class="testimonial-box">
              <p>{{item.comment}}</p>
              <div class="user-info">
                <img src="{{item.avatar}}" alt="avatar">
                <span>{{item.user}}</span>
              </div>
            </div>
          </ng-container>
        </div>
        <div *ngIf="isMobileView">
            
        </div>
      </div>
    
    </section>

    <section class="faq">
      <h2 class="font-regular">
        Frequently Asked Questions
      </h2>
      <div class="faq-container" role="group" aria-labelledby="AccID">
        <div class="faq-col">
            <ng-container *ngFor="let item of col1; let i = index">
            <details [attr.open]="expandedFaqIndex === i"  class="faq-item" [class.expanded]="expandedFaqIndex === i" [class.faq-expanded]="i === expandedFaqIndex" 
          
            (click)="toggleFaq($event,i)">
              <summary>
                <span>{{item.question}}</span>
                <img src="{{ i === expandedFaqIndex ? kingAseets.ChevronUpBlue : kingAseets.ChevronDownGrey}}" alt="{{item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'}}">
              </summary>
              <div class="body-wrapper" [@expandCollapse]="i === expandedFaqIndex ? 'expanded' : 'collapsed'">
                <hr>
                <p>{{item.answer}}</p>
              </div>
            </details>
          </ng-container>
          </div>
        <div class="faq-col">
            <ng-container *ngFor="let item of col2; let i = index">
            <details class="faq-item" [class.expanded]="i+col1.length === expandedFaqIndex" [class.faq-expanded]="i+col1.length === expandedFaqIndex" 
            [attr.open]="expandedFaqIndex === i+col1.length" 
            (click)="toggleFaq($event , i+col1.length)">
              <summary>
                <span>{{item.question}}</span>
                <img src="{{ i === expandedFaqIndex ? kingAseets.ChevronUpBlue : kingAseets.ChevronDownGrey}}" alt="{{item.isExpanded ? 'faq expanded icon' : 'faq collapsed icon'}}">
              </summary>
              <div [@expandCollapse]="i+col1.length === expandedFaqIndex ? 'expanded' : 'collapsed'">
                <hr>
                <p>{{item.answer}}</p>
              </div>
            </details>
          </ng-container>
          </div>

      </div>
    </section>
  </main>

  <footer>
    <div class="logo-container">
      <a class="king-logo" routerLink="/">
        <img src="{{kingAseets.KingLogoWhite}}" alt="king logo">
      </a>
      <div class="social-media-links">
        <ng-container *ngFor="let item of socialMediaLinks">
          <a href="{{item.link}}">
            <img src="{{item.icon}}" alt="{{item.alt}}">
          </a>
        </ng-container>
      </div>
    </div>
    <hr>
    <div class="rights">
      <span class="text-b1 font-regular">
        All rights are reserved for <span class="font-semi-bold">kingiftcard</span>
      </span>
    </div>
  </footer>
</div>
